
<template>
  <div class="app-container">
    <HeaderLogo />
    <div class="main-content">
      <div class="layout-flex">
        <div class="layout-left">
          <DormList
            :dorms="dorms"
            :selected-id="selectedDorm && selectedDorm.id"
            @select="handleSelectDorm"
          />
        </div>
        <div class="layout-right">
          <GroupTabs :groups="groups" :selected-dorm="selectedDorm" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import DormList from '@/components/DormList.vue'
import GroupTabs from '@/components/GroupTabs.vue'
import { getDeviceList,getDeviceToGroupMapList } from '@/api/api'
import { getWsClient } from '@/utils/wsInstance'
export default {
  name: 'DormGroup',
  components: { HeaderLogo, DormList, GroupTabs },
  data() {
    return {
      dorms: [
      ],
      groups: [
      
      ],
      selectedDorm: null,
      timer: null,
      wsClient:null
    }
  },
  mounted() {

  
    
  // 如果尚未显示过通知，则显示通知
    if (!localStorage.getItem('hasShownNotification')) {
      this.$notify({
        title: '提示',
        message: '所有页面数据已启用静默实时更新，无需担心数据是否为最新。',
        type: 'success',
        offset: 45,
        dangerouslyUseHTMLString: true,
        duration: 0,  // 设置为 0 表示通知不自动关闭
        iconClass: 'el-icon-check-circle',
        position: 'bottom-right',
        onClose: () => {
          // 当通知被关闭时，设置标记，表示通知已显示过
         
        }
      });
       localStorage.setItem('hasShownNotification', 'true');
    }


    // ✅ 页面加载时自动请求
    this.fetchDeviceList()
    this.timer = setInterval(this.fetchDeviceList, 5000)

    // const token = localStorage.getItem('token')
    // this.wsClient = getWsClient(token,{
    //   onMessage: (data) => this.handleWSMessage(data),
    //   onOpen: () => {
    //     this.status = '已连接'
    //     },
    //   onClose: () => (this.status = '断开，正在重连...')
    // })
  },
  beforeDestroy() {
  // ✅ 离开页面时清理定时器
  if(this.timer != null){
clearInterval(this.timer)
this.timer == null
  }
},
  methods: {
   async fetchDeviceList() {
  try {
    const [res1, res2] = await Promise.all([
      getDeviceList(),
      getDeviceToGroupMapList()
    ])

    if (res1.code === 0) {
      this.dorms = res1.data
    }
    if (res2.code === 0) {
      this.groups = res2.data
     const dormStatusMap = new Map(
  this.dorms.map(d => [d.id, d.status])
)

this.groups.forEach(g => {
  g.devices.forEach(d =>{
    const dormStatus = dormStatusMap.get(d.deviceId)
    d.status = dormStatus
  })
})


      
    }
  } catch (err) {
    console.log(err)
  }
},


    handleSelectDorm(dorm) {
    
      this.selectedDorm = dorm
    }
  }
}
</script>
<style scoped>

</style>